import React from "react";

const FontAwesomeIcon = ({ className }) => {
  return <i className={`fa ${className}`} />;
};

export default FontAwesomeIcon;
